<template>
    <BreadCrumb PageTitle="Liste des recensements" />
    <ListeRecensement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeRecensement from "@/components/Recensements/ListeRecensement.vue";

export default defineComponent({
    name: "ListeRecensementPage",
    components: {
        BreadCrumb,
        ListeRecensement,
    },
});
</script>
